import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import 'bootstrap/dist/css/bootstrap.min.css';

export default function CreatePortfolio() {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [image, setImage] = useState(null);
  const [url, setUrl] = useState("");
  const [isactive, setIsActive] = useState(1);
  const [sequence, setSequence] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);

  const handleImage = (e) => {
    setImage(e.target.files[0]);
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    setShowCreateModal(false);

    if (!name || !title || !description || !category || !image || !url) {
      toast.error("Missing required parameters.", {
        position: "top-center",
        autoClose: 1000,
        theme: "colored",
      });
      return;
    }
    const formData = new FormData();
    formData.append("name", name);
    formData.append("title", title);
    formData.append("description", description);
    formData.append("category", category);
    formData.append("image", image);
    formData.append("url", url);
    formData.append("isactive", isactive);
    formData.append("sequence", sequence);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}portfolio/createPortfolio`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        toast.success("Portfolio created successfully", {
          position: "top-center",
          autoClose: 1000,
          theme: "colored",
        });
        setTimeout(() => {
          navigate("/portfolioList");
        }, 2000);
      } else {
        toast.error("Portfolio was not added", {
          position: "top-center",
          autoClose: 1000,
          theme: "colored",
        });
      }
    } catch (err) {
      toast.error("An error occurred while creating the portfolio.", {
        position: "top-center",
        autoClose: 1000,
        theme: "colored",
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowCreateModal(true);
  };

  return (
    <>
      <div className="container mt-4">
        <div className="form-card">
          <div className="form-card-header">
            Create Portfolio
          </div>
          <div className="form-card-body">
            <Form onSubmit={handleSubmit}>

              {/* Row 1: Name & Title */}
              <Row className="mb-3">
                <Form.Group as={Col} controlId="name">
                  <Form.Label>Name:</Form.Label>
                  <Form.Control
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    maxLength={100}
                    required
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="title">
                  <Form.Label>Title:</Form.Label>
                  <Form.Control
                    type="text"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    maxLength={100}
                    required
                  />
                </Form.Group>
              </Row>

              {/* Row 2: Category & URL */}
              <Row className="mb-3">
                <Form.Group as={Col} controlId="category">
                  <Form.Label>Category:</Form.Label>
                  <Form.Control
                    type="text"
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                    maxLength={50}
                    required
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="url">
                  <Form.Label>URL:</Form.Label>
                  <Form.Control
                    type="url"
                    value={url}
                    onChange={(e) => setUrl(e.target.value)}
                    maxLength={255}
                    required
                  />
                </Form.Group>
              </Row>

              {/* Description */}
              <Form.Group className="mb-3" controlId="description">
                <Form.Label>Description:</Form.Label>
                <Form.Control
                  type="text"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  maxLength={255}
                  required
                />
              </Form.Group>

              {/* Row 3: Image & Sequence */}
              <Row className="mb-3">
                <Form.Group as={Col} controlId="image">
                  <Form.Label>Image:</Form.Label>
                  <Form.Control
                    type="file"
                    onChange={handleImage}
                    required
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="sequence">
                  <Form.Label>Sequence:</Form.Label>
                  <Form.Control
                    type="number"
                    value={sequence}
                    onChange={(e) => setSequence(e.target.value)}
                    required
                  />
                </Form.Group>
              </Row>

              {/* Toggle Switch for Is Active */}
              <div className="toggle-switch">
                <input
                  type="checkbox"
                  checked={isactive === 1}
                  onChange={(e) => setIsActive(e.target.checked ? 1 : 0)}
                />
                <span className="toggle-switch-label">Is Active</span>
              </div>

              {/* Form Actions */}
              <div className="form-actions">
                <button type="submit" className="btn-gradient-success">
                  Create Portfolio
                </button>
                <Link to="/portfolioList" className="btn-back-link">
                  ← Back to List
                </Link>
              </div>
            </Form>
          </div>
        </div>

        <ToastContainer />

        {/* Create Confirmation Modal */}
        <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Create New Portfolio</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to create this portfolio?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowCreateModal(false)}>
              Cancel
            </Button>
            <Button type="button" onClick={handleCreate} variant="primary">
              Create Portfolio
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}
